import { render, staticRenderFns } from "./GetOriginSample.vue?vue&type=template&id=95dd38a0&scoped=true&"
import script from "./GetOriginSample.vue?vue&type=script&lang=js&"
export * from "./GetOriginSample.vue?vue&type=script&lang=js&"
import style0 from "./GetOriginSample.vue?vue&type=style&index=0&id=95dd38a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dd38a0",
  null
  
)

export default component.exports